// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k7MN","colBig":"styles_colBig__1C5-O","colSmall":"styles_colSmall__2mJMt"};